import Header from "../components/Header";
import NewHeroSection from "../components/NewHeroSection";
import ViewMyRoofSection from "../components/ViewMyRoofSection";
import InsuranceUploadSection from "../components/InsuranceUploadSection";
import RoofingLeadForm from "../components/RoofingLeadForm";
import ServicesSection from "../components/ServicesSection";
import StormCenterSection from "../components/StormCenterSection";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <NewHeroSection />
        <ViewMyRoofSection />
        <StormCenterSection />
        <InsuranceUploadSection />
        <ServicesSection />
        <RoofingLeadForm />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
